import { useMutation } from '@tanstack/react-query';
import { markConversationImportant } from '../../services/chats';

interface Options {
  onSuccess?: (important: boolean) => void | Promise<void>;
  onError?: (important: boolean) => void | Promise<void>;
}

function useMarkChatImportant({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      conversationId,
      important,
    }: {
      conversationId: string;
      important: boolean;
    }) => {
      await markConversationImportant(conversationId, important);
      return important;
    },
    onSuccess,
    onError: (_, { important }) => onError?.(important),
  });
}

export default useMarkChatImportant;
